import RichTextPopup from './RichTextPopup';

export default RichTextPopup;